import React, { useEffect, useRef, useState } from 'react';
import { createTheme, Grid, ThemeProvider } from '@mui/material';
import { InteractieveTool } from '../Pages/InteractieveToolFusion/InteractieveTool';
import { InteractieveToolMobile } from '../Pages/InteractieveToolFusionMobile/InteractieveToolMobile';
import { useData } from '../../contexts';

export default function FusionData({ additionalData }: any): React.JSX.Element {
  const { interfaceColor, isDesktop } = useData();

  const theme = createTheme({
    palette: {
      primary: {
        main: interfaceColor,
      },
      secondary: {
        main: '#00ff00', // your secondary color
      },
    },
    typography: {
      allVariants: {
        fontFamily: 'Flanders Art Sans',
        fontSize: '1.4rem',
      },
    },
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            fontSize: '14px',
            display: 'inline',
            background: 'black',
          },
        },
      },
    },
  });

  const themeMobile = createTheme({
    palette: {
      primary: {
        main: interfaceColor,
      },
      secondary: {
        main: '#00ff00', // your secondary color
      },
    },
    typography: {
      allVariants: {
        fontFamily: 'Flanders Art Sans',
        fontSize: '13px',
      },
    },
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            fontSize: '11px',
            display: 'inline',
            background: 'black',
          },
        },
      },
    },
  });

  return (
    <>
      {isDesktop && (
        <ThemeProvider theme={theme}>
          <InteractieveTool additionalData={additionalData}></InteractieveTool>
        </ThemeProvider>
      )}
      {!isDesktop && (
        <ThemeProvider theme={themeMobile}>
          <InteractieveToolMobile
            additionalData={additionalData}
          ></InteractieveToolMobile>
        </ThemeProvider>
      )}
    </>
  );
}
